/* tslint:disable */
/* eslint-disable */
/**
 * Midcoast Water Bureau API
 * Backend API documentation for Midcoast Water Bureau application. This API provides endpoints for user management, device monitoring, water meter measurements, and notification systems.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: support@nucleus3.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { RequestDeleteAccountResponse } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { UpdatePassword } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { UserInfoResponse } from '../n3-backend-open-api-gen/model';
/**
 * UserApi - axios parameter creator
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the \'pending deletion\' status from the user\'s account, restoring full access.
         * @summary Cancel account deletion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDeleteAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/cancel-delete-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Forcefully wipes the user account from the system. This action is irreversible.
         * @summary Immediatelly delete user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/delete-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Places the user\'s account in a \'pending deletion\' state. Actual deletion usually occurs after a cooling-off period.
         * @summary Request account deletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeleteAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/request-delete-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json,*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes the current user\'s password. Requires the old password for validation. Standard security checks apply (must not be same as old password).
         * @summary Update user password
         * @param {UpdatePassword} updatePassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (updatePassword: UpdatePassword, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePassword' is not null or undefined
            assertParamExists('updatePassword', 'updatePassword', updatePassword)
            const localVarPath = `/api/v2/user/update-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves profile details for the currently authenticated user based on session context.
         * @summary Get current user information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json,*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the \'pending deletion\' status from the user\'s account, restoring full access.
         * @summary Cancel account deletion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDeleteAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDeleteAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.cancelDeleteAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Forcefully wipes the user account from the system. This action is irreversible.
         * @summary Immediatelly delete user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Places the user\'s account in a \'pending deletion\' state. Actual deletion usually occurs after a cooling-off period.
         * @summary Request account deletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestDeleteAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestDeleteAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestDeleteAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.requestDeleteAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Changes the current user\'s password. Requires the old password for validation. Standard security checks apply (must not be same as old password).
         * @summary Update user password
         * @param {UpdatePassword} updatePassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(updatePassword: UpdatePassword, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(updatePassword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updatePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves profile details for the currently authenticated user based on session context.
         * @summary Get current user information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Removes the \'pending deletion\' status from the user\'s account, restoring full access.
         * @summary Cancel account deletion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDeleteAccount(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.cancelDeleteAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * Forcefully wipes the user account from the system. This action is irreversible.
         * @summary Immediatelly delete user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * Places the user\'s account in a \'pending deletion\' state. Actual deletion usually occurs after a cooling-off period.
         * @summary Request account deletion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeleteAccount(options?: RawAxiosRequestConfig): AxiosPromise<RequestDeleteAccountResponse> {
            return localVarFp.requestDeleteAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * Changes the current user\'s password. Requires the old password for validation. Standard security checks apply (must not be same as old password).
         * @summary Update user password
         * @param {UpdatePassword} updatePassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(updatePassword: UpdatePassword, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updatePassword(updatePassword, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves profile details for the currently authenticated user based on session context.
         * @summary Get current user information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userInfo(options?: RawAxiosRequestConfig): AxiosPromise<UserInfoResponse> {
            return localVarFp.userInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 */
export class UserApi extends BaseAPI {
    /**
     * Removes the \'pending deletion\' status from the user\'s account, restoring full access.
     * @summary Cancel account deletion request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelDeleteAccount(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).cancelDeleteAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Forcefully wipes the user account from the system. This action is irreversible.
     * @summary Immediatelly delete user account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAccount(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Places the user\'s account in a \'pending deletion\' state. Actual deletion usually occurs after a cooling-off period.
     * @summary Request account deletion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requestDeleteAccount(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).requestDeleteAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Changes the current user\'s password. Requires the old password for validation. Standard security checks apply (must not be same as old password).
     * @summary Update user password
     * @param {UpdatePassword} updatePassword 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePassword(updatePassword: UpdatePassword, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updatePassword(updatePassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves profile details for the currently authenticated user based on session context.
     * @summary Get current user information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userInfo(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userInfo(options).then((request) => request(this.axios, this.basePath));
    }
}

